var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrochure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1692_45827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2796 13.7225C14.9868 13.4297 14.512 13.4297 14.2192 13.7225L13.2498 14.6919V10.1287C13.2498 9.71463 12.9141 9.37891 12.5 9.37891C12.0859 9.37891 11.7502 9.71463 11.7502 10.1287V14.6919L10.7808 13.7225C10.4879 13.4297 10.0132 13.4297 9.72033 13.7225C9.42753 14.0153 9.42753 14.49 9.72033 14.7829C12.1382 17.2007 12.0203 17.115 12.213 17.1948C12.4893 17.3093 12.8128 17.2497 13.0302 17.0323L15.2796 14.7829C15.5725 14.4901 15.5725 14.0153 15.2796 13.7225Z",
    fill: "#1075FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2491 20.2516H8.75103C8.33695 20.2516 8.00122 19.9158 8.00122 19.5018C8.00122 19.0877 8.33695 18.752 8.75103 18.752H16.2491C16.6633 18.752 16.9989 19.0877 16.9989 19.5018C16.9989 19.9158 16.6633 20.2516 16.2491 20.2516Z",
    fill: "#1075FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4971 7.49325C21.494 7.29206 21.4118 7.10784 21.2777 6.97377C14.1083 -0.195676 14.5042 0.175667 14.3532 0.0947811C14.111 -0.0347486 14.7948 0.00611607 5.13069 0.00611607C4.23275 0.00611607 3.5022 0.736665 3.5022 1.63461V22.3715C3.5022 23.2695 4.23275 24 5.13069 24H19.8691C20.7671 24 21.4976 23.2695 21.4976 22.3715C21.4976 22.1701 21.4979 7.55351 21.4971 7.49325ZM14.7493 6.62548V2.56611L18.9376 6.7544C14.5808 6.7544 14.8722 6.75586 14.8523 6.75178C14.7936 6.73973 14.7493 6.68767 14.7493 6.62548ZM19.998 22.3715C19.998 22.4426 19.9402 22.5004 19.8691 22.5004H5.13069C5.0596 22.5004 5.00182 22.4426 5.00182 22.3715V1.63456C5.00182 1.56347 5.0596 1.50569 5.13069 1.50569H13.2497V6.62548C13.2497 7.52343 13.9803 8.25398 14.8782 8.25398H19.998V22.3715Z",
    fill: "#1075FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1692_45827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrochure);
export default __webpack_public_path__ + "static/media/brochure.8ead98eeb68179cda0be1c88359c152d.svg";
export { ForwardRef as ReactComponent };